<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
        <div>
          <img src="@/assets/images/error.svg" id="errorImage" />
          <p id="errorText">{{ t('not-found') }}</p>
          <button
            v-if="showsRetryButton"
            v-on:click="retry"
            class="btn btn-secondary"
            id="retryButton"
          >
            {{ t('retry') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      scope: 'locale'
    })

    return { t }
  },

  props: {
    showsRetryButton: {
      type: Boolean,
      default: true
    }
  },

  emits: [
    'notfound:retry'
  ],

  methods: {
    retry() {
      this.$emit('notfound:retry')
    }
  }
})
</script>

<style lang="sass" scoped>
#errorImage
  display: block
  margin-left: auto
  margin-right: auto
  width: 100%

#errorText
  text-align: center

#retryButton
  display: block
  margin-left: auto
  margin-right: auto
  margin-top: 12px
</style>

<i18n>
{
  "de": {
    "not-found": "Der Inhalt konnte leider nicht gefunden werden.",
    "retry": "Erneut versuchen"
  },

  "en": {
    "not-found": "Der Inhalt konnte leider nicht gefunden werden.",
    "retry": "Erneut versuchen"
  }
}
</i18n>
